export const DEFAULT_LENS_ALIAS = 'wellarchitected'

export const naRiskTooltipMsg =
  'Number of questions marked as not applicable to this workload.'
export const highRiskTooltipMsg =
  'Indicates how many questions have high risk findings based on your answers and automated checks.'
export const mediumRiskTooltipMsg =
  'Indicates how many questions have medium risk findings based on your answers and automated checks.'

export const passCheckTolltioMsg =
  'Number of resource-level checks that are compliant with best practices.'
export const loadingCheckTolltioMsg =
  'Loading findings... This may take a few moments.'
export const failCheckTolltioMsg =
  'Number of resource-level checks that are non-compliant and need attention.'
export const totalTolltilMsg =
  '`Total number of checks run against AWS resources for this workload.'
export const qnATooltipMsg =
  'Tracks how many questions you have completed out of the total in this WAFR.'

export const maxCharLimitNotes = 'Maximum character limit of 250 exceeded.'
export const maxCharLimitQuestionNotes =
  'Maximum character limit of 2048 exceeded.'

export const uniqueAccountIDErr = 'Account Id must be unique'

export const ftrLockedAssessmentMsg =
  'This assessment is locked. Unlock to update answers.'
export const ftrLockedNotesMsg =
  'Please answer at least one question below to unlock this section.'
export const ftrLockedFieldMsg =
  'This field is locked. Please answer questions in below subsections.'

export const emptyWorkloadAssessment = {
  workloadId: '',
  workloadName: '',
  reviewOwner: '',
  description: '',
  environment: '',
  hostedRegion: '',
  architecturalDesign: '',
  industryType: '',
  industry: '',
  workloadArn: '',
  scope: [
    {
      accountId: '',
      awsRegions: [
        {
          region: '',
          regionName: '',
        },
      ],
    },
  ],
}

export const checksArray = [
  {
    status: '',
    label: 'Total',
    count: 0,
  },
  {
    status: 'pass',
    label: 'Passed',
    count: 0,
  },
  {
    status: 'fail',
    label: 'Failed',
    count: 0,
  },
]

export const PILLAR_NAMES: { [key: string]: string } = {
  operationalExcellence: 'Operational excellence',
  security: 'Security',
  reliability: 'Reliability',
  performance: 'Performance efficiency',
  costOptimization: 'Cost optimization',
  sustainability: 'Sustainability',
}

export const PILLAR_PATHS: { [key: string]: string } = {
  operationalExcellence: '/operational-excellence',
  security: '/security',
  reliability: '/reliability',
  performance: '/performance',
  costOptimization: '/cost-optimization',
  sustainability: '/sustainability',
}

export const SECTION_PATHS: { [key: string]: string } = {
  partnerHosted: '/partner-hosted',
  supportLevel: '/support-level',
  architectureReview: '/architecture-review',
  alternateReviewProcessAwsWellArchitectedReview:
    '/alternate-review-process-aws-well-architected-review',
  awsRootAccount: '/aws-root-account',
  communicationsFromAws: '/communications-from-aws',
  identityAndAccessManagement: '/identity-and-access-management',
  operationalSecurity: '/operational-security',
  networkSecurity: '/network-security',
  backupsAndRecovery: '/backups-and-recovery',
  resiliency: '/resiliency',
  amazonS3BucketAccess: '/amazon-s3-bucket-access',
  crossAccountAccess: '/cross-account-access',
  sensitiveData: '/sensitive-data',
  regulatoryComplianceAndValidationProcess:
    '/regulatory-compliance-and-validation-process',
}
